import * as React from 'react';
import {
  Button,
  Dialog, DialogActions, DialogTitle,
  Typography,
} from '@material-ui/core';

interface ImproperlyPackedDialogProps {
  trackingNumber?: string;
  showModal: boolean;
  onClose: (value?: Array<string>) => void;
  markOverride: () => void;
}

const DuplicateTrackingNumberDialog: React.FC<ImproperlyPackedDialogProps> = (
  {
    trackingNumber = '', showModal, onClose, markOverride,
  },
) => {
  const handleCancel = () => {
    onClose();
  };

  return (
    <Dialog open={showModal}>
      <DialogTitle>
        <Typography variant="overline">
          {'CURRENT BOX · #'}
          {trackingNumber}
        </Typography>
        <Typography variant="h5" id="dialog-header">{'Duplicate tracking number has been scanned.'}</Typography>
        <Typography variant="body2" color="textSecondary">
          {'Do you want to add it in the system again?'}
        </Typography>
      </DialogTitle>
      <DialogActions>
        <Button color="secondary" variant="text" onClick={handleCancel}>{"NO, DON'T ADD"}</Button>
        <Button color="primary" variant="contained" onClick={markOverride}>{'YES, ADD IT AGAIN'}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default DuplicateTrackingNumberDialog;
